import React from 'react';
import {affiliatesKeysOfInterest, ignoreKeys} from '../../LookupUtils';
import {checkKey} from '../../../../helpers/constants/ckeckLookupKeys';
import {chevronRight} from '../../../../assets/images/images';
import moment from 'moment';

export const LookupContent = ({
  env,
  lookupImage,
  sandbox_dummy,
  formatKey,
  lastNames,
  firstNames,
  companyNames,
  lookupData,
  lookupKeys,
  showAffiliateDetails,
  setShowAffiliateDetails,
  callerName = '',
}) => (
  <div className="">
    <div className="py-8 flex flex-col items-center border border-transparent border-b-[#EFEFEF]">
      {env !== 'Sandbox' ? (
        <>
          {lookupImage ? (
            <div className="px-6 flex items-center gap-[18px] w-full">
              <img
                src={
                  lookupImage?.startsWith('https')
                    ? lookupImage
                    : `data:image/png;base64,${lookupImage}`
                }
                alt="User Image"
                width={72}
                height={72}
                className="text-small w-[72px] h-[72px] rounded-full object-cover"
              />
              <div className="flex items-start flex-col gap-1">
                <h1 className="text-[#080917] capitalize font-medium text-base">
                  {lookupData?.first_name} {lookupData?.middle_name}{' '}
                  {lookupData?.last_name}
                </h1>
                <div className="flex  gap-2 text-start flex-col">
                  <p className="text-[#858DAA] text-xs font-medium uppercase">
                    performed by:{' '}
                    <span className="text-[#080917] font-semibold">
                      {callerName
                        ? callerName
                        : lookupData?.caller_name || lookupData?.caller_email
                        ? lookupData?.caller_name || lookupData?.caller_email
                        : '-'}
                    </span>
                  </p>
                  {/*<p className="text-[#858DAA] text-xs font-medium uppercase">*/}
                  {/*  Generated:{' '}*/}
                  {/*  {lookupData?.date_created*/}
                  {/*    ? moment(lookupData?.date_created).format(*/}
                  {/*        'MMM DD, YYYY hh:mmA',*/}
                  {/*      )*/}
                  {/*    : '-'}*/}
                  {/*</p>*/}
                </div>
              </div>
            </div>
          ) : (
            <div className="h-[110px] w-[110px] rounded-full bg-brandBlue40 text-brandBlue flex justify-center items-center text-xxl">
              {lastNames.map(
                name => `${lookupData[name]?.substr(0, 1) || '-'}`,
              )}
              {firstNames.map(
                name =>
                  `${
                    companyNames.includes(name)
                      ? lookupData[name]?.split(' ')[1]?.substr(0, 1)
                      : lookupData[name]?.substr(0, 1) || '-'
                  }`,
              )}
            </div>
          )}
        </>
      ) : (
        <img
          src={sandbox_dummy}
          alt="Photo"
          width={72}
          height={72}
          className="text-small w-[72px] h-[72px] rounded-full object-cover"
        />
      )}
    </div>

    <div className="px-6 py-3 bg-white -mx-4 sm:mx-0 rounded">
      {lookupKeys?.map(key => (
        <React.Fragment key={key}>
          {!ignoreKeys.includes(key?.toLowerCase()) && (
            <div
              className={`py-3.5 flex items-center justify-between ${
                key === 'affiliates' && showAffiliateDetails ? '' : ''
              } `}
            >
              <p className="text-small text-[#0B1C56] font-medium capitalize text-left">
                {key === 'affiliates' ? 'Number of Affiliates' : checkKey(key)}
              </p>

              <div className="text-sm text-[#5C688E] w-100 text-right">
                {key === 'affiliates' ? (
                  <div className="flex items-center gap-1">
                    <button
                      type="button"
                      className="text-sm font-medium text-brandBlue cursor-pointer -mb-1"
                      onClick={() => setShowAffiliateDetails(prev => !prev)}
                    >
                      {showAffiliateDetails ? (
                        <>
                          <span className="text-body">
                            {lookupData[key]?.length}{' '}
                          </span>
                          <span>minimize details</span>
                        </>
                      ) : (
                        'Expand details'
                      )}
                    </button>
                    <img
                      src={chevronRight}
                      alt="right arrow"
                      width={16}
                      height={16}
                    />
                  </div>
                ) : (
                  <span>
                    {(lookupKeys &&
                    typeof lookupData[key] !== 'object' &&
                    ['createdAt', 'updatedAt'].includes(key)
                      ? moment(lookupData[key]).format('DD MMM YYYY h:m')
                      : lookupData[key]) || '-'}
                  </span>
                )}
              </div>
            </div>
          )}
          {key === 'affiliates' && showAffiliateDetails && (
            <div className="flex flex-col gap-2 w-full px-6">
              {lookupData[key]?.map((affiliate, index) => (
                <div
                  key={index}
                  className="bg-[#F3F3F3] py-4 px-2.5 flex flex-col items-start gap-4 rounded-lg"
                >
                  <p className="uppercase text-grey text-xs font-medium">{`Affiliate ${
                    index + 1
                  }`}</p>

                  <div className="flex flex-col gap-2 w-full">
                    {affiliatesKeysOfInterest?.map(detailKey => (
                      <div
                        key={detailKey}
                        className="flex items-center justify-between gap-6 border-b border-grey60 w-full py-2"
                      >
                        <p className="uppercase text-xs font-medium text-[#5E5E5E]">
                          {formatKey(detailKey)}
                        </p>
                        <p className="text-sm font-medium text-grey text-end capitalize">
                          {affiliate[detailKey] || '-'}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  </div>
);
